import { Component, OnInit } from '@angular/core';
import { ActivityService } from '@stockcare-services/activity-service/activity.service';
import { AuthenticationService } from '@stockcare-services/authentication/authentication.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit {
  constructor(private activityService: ActivityService, private router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    this.authenticationService.logout();
    this.activityService.stop();
    this.router.navigate(['app/authentication/login']);
  }
}
